module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"notLoggedIn":"Not logged in","action":{"logOut":"Log out"},"alert":{"logOut":"You have logged out successfully."}}}')
  delete Component.options._Ctor
}
